import { Sparkles } from "lucide-react";

export const ModuleCard = ({ index, module }) => {
  return (
    <div className="module-card" data-testid={`module-card-${index + 1}`}>
      <div className="logic-panel rounded-[1.75rem] p-6 text-center md:hidden" data-testid={`module-card-mobile-${index + 1}`}>
        <div className="flex items-center justify-between gap-4">
          <span className="text-xs uppercase tracking-[0.35em] text-white/52" data-testid={`module-card-mobile-number-${index + 1}`}>
            módulo {String(index + 1).padStart(2, "0")}
          </span>
          <Sparkles className="h-4 w-4 text-cyan-300" />
        </div>

        <div className="mt-5 space-y-4">
          <h3 className="text-2xl font-semibold text-white" data-testid={`module-card-mobile-title-${index + 1}`}>
            {module.title}
          </h3>
          <p className="text-base leading-relaxed text-white" data-testid={`module-card-mobile-summary-${index + 1}`}>
            {module.summary}
          </p>
        </div>

        <div className="mt-5 rounded-2xl border border-white/10 bg-black/25 px-4 py-4">
          <p className="text-xs uppercase tracking-[0.26em] text-cyan-200" data-testid={`module-card-mobile-label-${index + 1}`}>
            Resultado prático
          </p>
          <p className="mt-3 text-base leading-relaxed text-white" data-testid={`module-card-mobile-result-${index + 1}`}>
            {module.result}
          </p>
        </div>
      </div>

      <div className="module-card-inner hidden md:block">
        <div className="module-card-face logic-panel rounded-[1.75rem] p-6 md:p-7">
          <div className="flex items-center justify-between gap-4">
            <span className="text-xs uppercase tracking-[0.35em] text-white/45" data-testid={`module-card-front-number-${index + 1}`}>
              módulo {String(index + 1).padStart(2, "0")}
            </span>
            <Sparkles className="h-4 w-4 text-cyan-300" />
          </div>

          <div className="space-y-4 text-center">
            <h3 className="text-2xl font-semibold text-white" data-testid={`module-card-front-title-${index + 1}`}>
              {module.title}
            </h3>
            <p className="text-base leading-relaxed text-white/88" data-testid={`module-card-front-summary-${index + 1}`}>
              {module.summary}
            </p>
          </div>

          <div className="flex items-center justify-between text-sm text-white/48">
            <span data-testid={`module-card-front-hover-${index + 1}`}>Passe o Mouse</span>
            <span>↗</span>
          </div>
        </div>

        <div className="module-card-face module-card-face--back logic-panel rounded-[1.75rem] p-6 md:p-7">
          <div className="space-y-4 text-center">
            <span className="inline-flex w-fit rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs uppercase tracking-[0.26em] text-cyan-200" data-testid={`module-card-back-label-${index + 1}`}>
              Resultado prático
            </span>
            <h3 className="text-2xl font-semibold text-white" data-testid={`module-card-back-title-${index + 1}`}>
              {module.title}
            </h3>
            <p className="text-base leading-relaxed text-white" data-testid={`module-card-back-result-${index + 1}`}>
              {module.result}
            </p>
          </div>

          <div className="rounded-2xl border border-white/10 bg-black/25 px-4 py-3 text-center text-sm text-white/78" data-testid={`module-card-back-footer-${index + 1}`}>
            {module.summary}
          </div>
        </div>
      </div>
    </div>
  );
};